import jsPDF from "jspdf";
import "jspdf-autotable";
import { deliverPdf } from "./helpers/pdfDelivery.js"
import { drawPdfLogo } from "./helpers/pdfLogo.js"

const formatCurrency = (value) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);

const formatVendedorPdf = (value) => {
  if (value === true) return "Si";
  if (typeof value === "string") return value;
  return "";
};

const buildFiltrosTexto = ({ fechaDesde, fechaHasta, destino, servicio, proveedor, categoria, orden }) => {
  const filtros = [];

  if (fechaDesde || fechaHasta) {
    filtros.push(`Fecha: ${fechaDesde || "N/A"} - ${fechaHasta || "N/A"}`);
  }
  if (destino) filtros.push(`Destino: ${destino}`);
  if (servicio) filtros.push(`Servicio: ${servicio}`);
  if (proveedor) filtros.push(`Proveedor: ${proveedor}`);
  if (categoria) filtros.push(`Categoria: ${categoria}`);
  if (orden) filtros.push(`Orden: ${orden}`);

  return filtros.length ? filtros : ["Filtros: Todos"];
};

export const generarPdfVerServicios = ({ rows = [], filtros = {}, usuario = "Usuario", logoBase64 = null, deliveryContext = null }) => {
  if (!Array.isArray(rows) || rows.length === 0) return false;

  const doc = new jsPDF({ unit: "pt", format: "a4", orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 20;

  const PAL = {
    primary: [25, 118, 210],
    ink: [33, 33, 33],
    muted: [117, 117, 117],
    inkLight: [158, 158, 158],
    bgSoft: [245, 247, 250],
  };

  const totalCosto = rows.reduce((sum, row) => sum + (Number(row?.costo) || 0), 0);

  drawPdfLogo({ doc, logoBase64, x: margin, y: margin, maxW: 80, maxH: 36 })

  let yPosition = 36;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(...PAL.primary);
  doc.text("REPORTE VER SERVICIOS", pageWidth / 2, yPosition, {
    align: "center",
  });
  yPosition += 20;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...PAL.inkLight);
  doc.text(
    `Fecha de generacion: ${new Date().toLocaleString("es-AR")} | Usuario: ${usuario}`,
    pageWidth - margin,
    yPosition,
    { align: "right" }
  );
  yPosition += 24;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(...PAL.ink);
  doc.text("Filtros aplicados:", margin, yPosition);
  yPosition += 14;

  doc.setDrawColor(...PAL.primary);
  doc.setLineWidth(1);
  doc.line(margin, yPosition, pageWidth - margin, yPosition);
  yPosition += 12;

  const filtrosTexto = buildFiltrosTexto(filtros);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...PAL.muted);
  doc.text(filtrosTexto.join(" | "), margin, yPosition, {
    maxWidth: pageWidth - margin * 2,
  });
  yPosition += 24;

  doc.setFillColor(...PAL.bgSoft);
  doc.roundedRect(margin, yPosition - 13, 760, 20, 3, 3, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...PAL.ink);
  doc.text(
    `Registros: ${rows.length} | Costo Total: ${formatCurrency(totalCosto)}`,
    margin + 8,
    yPosition
  );
  yPosition += 24;

  const head = [
    "Fecha",
    "Destino",
    "Servicio",
    "Proveedor",
    "Costo",
    "Categoria",
    "Vendedor",
  ];

  const body = rows.map((row) => [
    row?.fecha || "N/A",
    row?.destino || "",
    row?.servicio || "",
    row?.proveedor || "",
    formatCurrency(row?.costo),
    row?.categoria || "",
    formatVendedorPdf(row?.vendedor ?? row?.esVendedor),
  ]);

  doc.autoTable({
    startY: yPosition,
    head: [head],
    body,
    theme: "grid",
    headStyles: {
      fillColor: PAL.primary,
      fontSize: 9,
      fontStyle: "bold",
      halign: "center",
      textColor: [255, 255, 255],
    },
    bodyStyles: {
      fontSize: 8,
      cellPadding: 4,
      textColor: PAL.ink,
    },
    alternateRowStyles: {
      fillColor: [250, 250, 250],
    },
    columnStyles: {
      0: { cellWidth: 70, halign: "center" },
      1: { cellWidth: 120 },
      2: { cellWidth: 120 },
      3: { cellWidth: 140 },
      4: { cellWidth: 85, halign: "right" },
      5: { cellWidth: 120 },
      6: { cellWidth: 120, halign: "center" },
    },
    margin: { left: margin, right: margin },
    didDrawPage: (data) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(...PAL.inkLight);
      const pageText = `Pagina ${data.pageNumber} de ${doc.internal.pages.length - 1}`;
      doc.text(pageText, pageWidth / 2, pageHeight - 20, { align: "center" });
    },
  });

  const fileName = `ver_servicios_${new Date().toISOString().slice(0, 10)}.pdf`;
  doc.setProperties({ title: fileName, subject: "Reporte Ver Servicios", creator: "Sistema" })
  deliverPdf({ doc, fileName, targetWindow: deliveryContext?.targetWindow || null })
  return true;
};
